import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ListingsPage = lazy(() => import('../pages/listings/page'));
const ListingDetailPage = lazy(() => import('../pages/listing-detail/page'));
const CreateListingPage = lazy(() => import('../pages/create-listing/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const WhatsAppResetPinPage = lazy(() => import('../pages/auth/whatsapp-reset-pin/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ManageListingsPage = lazy(() => import('../pages/profile/listings/page'));
const ProfileMessagesPage = lazy(() => import('../pages/profile/messages/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/home',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/home/',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/listings',
    element: <ListingsPage />,
  },
  {
    path: '/listing',
    element: <Navigate to="/listings" replace />,
  },
  {
    path: '/listing/',
    element: <Navigate to="/listings" replace />,
  },
  {
    path: '/listing/:id',
    element: <ListingDetailPage />,
  },
  {
    path: '/listing/:id/:slug',
    element: <ListingDetailPage />,
  },
  {
    path: '/create-listing',
    element: <CreateListingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/auth/whatsapp-reset-pin',
    element: <WhatsAppResetPinPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/profile/listings',
    element: <ManageListingsPage />,
  },
  {
    path: '/profile/messages',
    element: <ProfileMessagesPage />,
  },
  {
    path: '/contact/:token',
    element: <ContactPage />,
  },
  {
    path: '/contact/listing/:listingId',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
